
import ListComponent from "../../../components/add_balance_records/Index.vue";

export default {
  components: {
    ListComponent
  }
}
